@if (isThemeLoaded) {
    <div class="relative h-screen bg-gray-600">
        <router-outlet></router-outlet>
        <!-- Safe mode: glowing inset border overlay -->
        @if (safeModeService.isEnabled) {
            <div
                class="safe-mode-border pointer-events-none fixed inset-0 z-[9999]"
            ></div>
        }
        <!-- Safe mode: floating badge -->
        @if (safeModeService.isEnabled) {
            <div
                class="fixed bottom-4 left-1/2 z-[9999] flex -translate-x-1/2 items-center gap-2 rounded-full bg-amber-500/90 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-white shadow-lg shadow-amber-500/25"
            >
                <i class="fa-light fa-shield-check"></i>
                safe mode
            </div>
        }
    </div>
}

<app-toaster></app-toaster>
<mnm-main></mnm-main>
<app-easter-alert></app-easter-alert>
